import React, { Component } from "react";
import { Link } from "react-router-dom";

class About extends Component {
  render() {
    return (
      <div>
        {/* <!-- Post --> */}
        <article class="post">
          <header>
            <div class="title">
              <h2>
                <a href="single.html">About Me.</a>
              </h2>
              <p>
                UT Dallas Computer Science Class of 2022
              </p>
            </div>
          </header>

          <p>
            I’m currently finishing my Bachelors in Computer Science at the University of Texas at Dallas.
            <br />
            <br />I’ll soon be starting a full time Software Engineering position with JPMorgan Chase & Co. in July 2022.
            <br />
            <br />
            Previously worked at Orthofix, USAA, Stream Energy, and J.P. Morgan Chase & Co.
            <br />
            <br />
            In 2017, I started Ensign Consultants, a consulting company focused on Website Development, React Web Applications, React Native Mobile Applications, and Digital Marketing Services.

          </p>
        </article>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js